module.exports = __webpack_public_path__ + "static/media/mycenaean_preview.e010670a.png";